import React from "react";

interface DownloadsProps {
	available?: boolean;
	description: string;
}

export function Downloads({ available = true, description }: DownloadsProps) {
	return (
		<div className="subscription__downloads">
			<div className="content">
				<p className="h4">Data downloads</p>
				<div className="typography">
					<p>{description}</p>
				</div>
			</div>
			{available && (
				<div className="btn-group">
					<a
						className="btn btn--dark"
						href="mailto:sales@ch-aviation.com"
					>
						Request a quote
					</a>
				</div>
			)}
		</div>
	);
}
